import styled from "styled-components";
import { responsiveWidth } from "responsive";

export const Wrapper = styled.div`
  background: linear-gradient(180deg, #0a0a0a 0%, #111111 100%);
  color: #cfcfcf;
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
  z-index: 999999999 !important;
  pointer-events: auto !important;

  &.footer-none {
    display: none;
  }
`;

export const Container = styled.div`
  ${responsiveWidth}
  width: 100%;
  margin: 0 auto;
  padding: 64px 0 28px;
`;

export const Columns = styled.div`
  display: grid;
  grid-template-columns: minmax(360px, 1.35fr) minmax(520px, 1fr);
  gap: clamp(32px, 6vw, 80px);
  padding-top: 6px;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 40px;
  }
`;

export const CompanyColumn = styled.div`
  min-width: 0;
`;

export const InfoColumns = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 64px;
  min-width: 0;

  @media (max-width: 1024px) {
    gap: 40px;
  }

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
    gap: 26px;
  }
`;

export const Column = styled.div`
  min-width: 0;
`;

export const Logo = styled.img`
  display: block;
  width: 100px;
  height: auto;
  margin-bottom: 18px;
`;

export const Caption = styled.div`
  font-family: 'SpoqaHanSansNeo-Regular', 'Apple SD Gothic Neo', sans-serif;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #9a9a9a;
  margin-bottom: 10px;
`;

export const CompanyName = styled.div`
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 14px;

  .name {
    font-family: 'SpoqaHanSansNeo-Regular', 'Apple SD Gothic Neo', sans-serif;
    font-size: 20px;
    font-weight: 700;
    color: #ffffff;
    letter-spacing: -0.02em;
  }

  .sep {
    font-size: 14px;
    font-weight: 400;
    color: #4a4a4a;
  }

  .meta {
    font-family: 'SpoqaHanSansNeo-Regular', 'Apple SD Gothic Neo', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #cfcfcf;
    letter-spacing: -0.02em;

    .key {
      color: #9a9a9a;
      font-weight: 700;
      margin-right: 6px;
    }

    strong {
      color: #ffffff;
      font-weight: 700;
    }
  }
`;

export const InfoLine = styled.div`
  font-family: 'SpoqaHanSansNeo-Regular', 'Apple SD Gothic Neo', sans-serif;
  font-size: 13px;
  line-height: 1.55;
  letter-spacing: -0.02em;
  color: #cfcfcf;

  span {
    color: #9a9a9a;
    font-weight: 700;
    margin-right: 6px;
  }
`;

export const AddressBlock = styled.div`
  margin-top: 0;

  & + & {
    margin-top: 22px;
  }

  strong {
    display: block;
    font-family: 'SpoqaHanSansNeo-Regular', 'Apple SD Gothic Neo', sans-serif;
    font-size: 13px;
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 4px;
  }

  p {
    margin: 0;
    font-family: 'SpoqaHanSansNeo-Regular', 'Apple SD Gothic Neo', sans-serif;
    font-size: 13px;
    line-height: 1.5;
    letter-spacing: -0.02em;
    color: #cfcfcf;
  }
`;

export const SupportLabel = styled.div`
  font-family: 'SpoqaHanSansNeo-Regular', 'Apple SD Gothic Neo', sans-serif;
  font-size: 13px;
  font-weight: 700;
  color: #ffffff;
  margin-top: 24px;
  margin-bottom: 4px;

  ${Caption} + & {
    margin-top: 0;
  }
`;

export const PhoneBig = styled.div`
  font-family: 'SpoqaHanSansNeo-Regular', 'Apple SD Gothic Neo', sans-serif;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.3;
  letter-spacing: -0.02em;
  color: #ffffff;
  margin-bottom: 4px;

  @media (max-width: 767px) {
    font-size: 20px;
  }
`;

export const Email = styled.div`
  font-family: 'SpoqaHanSansNeo-Regular', 'Apple SD Gothic Neo', sans-serif;
  font-size: 13px;
  line-height: 1.5;
  letter-spacing: -0.02em;
  color: #cfcfcf;
`;

export const HoursLine = styled.div`
  font-family: 'SpoqaHanSansNeo-Regular', 'Apple SD Gothic Neo', sans-serif;
  font-size: 13px;
  line-height: 1.5;
  letter-spacing: -0.02em;
  color: #cfcfcf;

  &.dim {
    color: #7a7a7a;
  }
`;

export const Divider = styled.div`
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  margin: 34px 0 18px;
`;

export const BottomBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;

  @media (max-width: 767px) {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
  }
`;

export const TermsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px 14px;
  align-items: center;
  flex: 1;
  min-width: 0;
`;

export const TermItem = styled.div`
  font-family: 'SpoqaHanSansNeo-Regular', 'Apple SD Gothic Neo', sans-serif;
  font-size: 13px;
  line-height: 1.4;
  letter-spacing: -0.02em;
  color: #b5b5b5;
  cursor: pointer;
  user-select: none;
  transition: color 0.15s ease;

  &:hover {
    color: #ffffff;
  }
`;

export const BottomRight = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;

  @media (max-width: 767px) {
    justify-content: space-between;
  }
`;

export const SnsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const SnsButton = styled.button`
  width: 38px;
  height: 38px;
  padding: 0;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
  color: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;

  svg {
    width: 16px;
    height: 16px;
    stroke-width: 1.6;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.16);
    border-color: rgba(255, 255, 255, 0.14);
  }
`;

export const TextMin = styled.div`
  font-family: 'SpoqaHanSansNeo-Regular', 'Apple SD Gothic Neo', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.3;
  letter-spacing: -0.05em;
  text-align: left;
  color: #7a7a7a;
  margin-top: 12px;
  width: 100%;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
`;

export const ContainerTerm = styled.div`
  ${responsiveWidth}
  position: relative;
  z-index: 1;
  width: 100%;
  margin: 0 auto;
  padding: 14px 0 0;
`;